const Name = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name';

const parseJwt = (token) => {
  if (!token) {
    return false;
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

const getNameFromToken = (token) => {
  const user = parseJwt(token);
  if (user) {
    const name = user.FullName ? user.FullName : user[Name];
    return name || 'User';
  }
  return 'User';
};

export default getNameFromToken;
